import { mixed, object } from "yup";

import type { I18nT } from "@lib/dashboardI18n";
import "@lib/messageComposition/chatMessaging/yupHelper";
import type {
  SHARED_CONSTANTS_RCS_MESSAGE_TYPES,
  SHARED_CONSTANTS_RICH_CARD_ALIGNMENTS,
  SHARED_CONSTANTS_RICH_CARD_ORIENTATIONS,
} from "@lib/shared_constants";
import sharedConstants from "@lib/shared_constants";

import { getRcsRichCardButtonSchema } from "../suggested_actions";
import { getRcsActionsSchema, getRcsBaseSchema } from "..";

export const getRcsBaseRichCardSchema = (t: I18nT<"rcs-composer">, isTwilioProvider?: boolean) => {
  const base = isTwilioProvider ? getRcsBaseSchema(t) : getRcsBaseSchema(t).concat(getRcsActionsSchema(t));

  return base
    .concat(
      object({
        type: mixed<SHARED_CONSTANTS_RCS_MESSAGE_TYPES["RICH_CARD"]>()
          .oneOf([sharedConstants.RCS.MESSAGE_TYPES.RICH_CARD])
          .required(),
        orientation: mixed<SHARED_CONSTANTS_RICH_CARD_ORIENTATIONS[keyof SHARED_CONSTANTS_RICH_CARD_ORIENTATIONS]>()
          .oneOf(Object.values(sharedConstants.RCS.RICH_CARD_ORIENTATIONS))
          .default(sharedConstants.RCS.RICH_CARD_ORIENTATIONS.VERTICAL)
          .required(),
        alignment: mixed<SHARED_CONSTANTS_RICH_CARD_ALIGNMENTS[keyof SHARED_CONSTANTS_RICH_CARD_ALIGNMENTS]>()
          .oneOf(Object.values(sharedConstants.RCS.RICH_CARD_ALIGNMENTS))
          .default(sharedConstants.RCS.RICH_CARD_ALIGNMENTS.LEFT)
          .required(),
        buttons: getRcsRichCardButtonSchema(t).required(),
      })
    )
    .noUnknown();
};
